// Opens a larger scan of a newspaper clipping (sections/press-group.liquid) in a dialog.
(() => {
  if (window.klpdPressZoom) return;
  window.klpdPressZoom = true;

  let dialog;

  const getDialog = () => {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'press-zoom';
    dialog.innerHTML = '<button type="button" class="press-zoom__close" aria-label="Close">&times;</button><img alt="">';
    dialog.querySelector('.press-zoom__close').addEventListener('click', () => dialog.close());
    // Click on the dark backdrop closes it
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    document.body.appendChild(dialog);
    return dialog;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-press-zoom]');
    if (!button) return;
    const zoom = getDialog();
    const image = zoom.querySelector('img');
    image.src = button.dataset.pressZoom;
    image.alt = button.dataset.pressZoomAlt || '';
    zoom.showModal();
  });
})();
